import { createContext } from 'react';

const WaterSearchContext = createContext({
  waterSearch: [],
  setWaterSearch: waterSearch => {}
});

export default WaterSearchContext;
